<script lang="ts">
    import router from "../../node_modules/page/index";
    import { useLocation } from 'svelte-navigator';
    import routes from './LayoutRouter.js';
    let page = null;
    let params = {};
    let location = useLocation()
    routes.forEach((route) => {
      router(
        route.path,
        (ctx, next) => {
          params = { ...ctx.params };
          next();
        },
        () => page = route.component);
      });
      
    router.start();
    if ((window.location.pathname === '/' || window.location.pathname === '/dashboard/default')) {
      if($location.search == ""){
        router.redirect("/dashboard/default")
      }else{
        router.redirect("/dashboard/default" + $location.search)
      }
    }
  </script>
  
  <svelte:component this={page} {params} />
  <!-- For taking the change on window.location.pathname -->
  <svelte:window />
  